<template>
  <div id="app">
    <edgeBanner />
    <router-view></router-view>
  </div>
</template>

<script>
  import marked from 'marked';
  export default {
    name: 'app'
  }

</script>

<style lang="scss">
  @import './assets/scss/main';

  #app {
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// App.vue?5f587a40